import { IValidationProperties } from '../types/validation';
import axios from 'axios';
import { store } from '../redux/store';
import validationFallback from '../assets/data/validation-properties-fallback.json';

class ValidationService {
  public async getValidationProperties(): Promise<IValidationProperties> {
    return await axios
      .get(`${this.apiConfig().apiRoot}/v4/validation/properties`)
      .then((r) => {
        return r.data;
      })
      .catch((_) => {
        return validationFallback;
      });
  }

  private apiConfig = () => store.getState().apiConfig;
}

export const validationService = new ValidationService();
